//我们组装模块并导出 store 的地方
import Vue from "vue";
import Vuex from "vuex";
import authModule from "./modules/auth";
import permission from "./modules/permission";
import middleware from "./modules/middleware";
import oss from "./modules/oss";
import common from "./modules/common";
import getters from "./getters";
import orderForm from "./modules/orderForm";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    authModule,
    permission,
    middleware,
    oss,
    common,
    orderForm,
  },
  getters,
  strict: false, //process.env.NODE_ENV !== 'production',
});

if (module.hot) {
  // 使 actions 和 mutations 成为可热重载模块
  module.hot.accept(
    [
      "./modules/auth",
      "./modules/permission",
      "./modules/middleware",
      "./modules/common",
    ],
    () => {
      // 获取更新后的模块
      // 因为 babel 6 的模块编译格式问题，这里需要加上 .default
      // 加载新模块
      store.hotUpdate({
        modules: {
          authModule: require("./modules/auth").default,
          common: require("./modules/common").default,
          permission: require("./modules/permission").default,
          middleware: require("./modules/middleware").default,
        },
      });
    },
  );
}

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js